<main class="mediumContainer">
    <div class="d-flex flex-row flex-space-between admin-page-header">
        <button (click)="back()" (keyup.enter)="back()" aria-label="Back" mat-icon-button matTooltip="Back">
            <mat-icon>keyboard_backspace</mat-icon>
        </button>
        <h1 class="admin-page-title">Settings</h1>
        <div class="admin-page-header-spacer" aria-hidden="true"></div>
    </div>
    <div>
        <mat-card class="w-100 main-card">
            <mat-card-content>
                <mat-tab-group animationDuration="0ms" class="tab-row" fitInkBarToContent>
                    <mat-tab label="Profile">
                        <form [formGroup]="profileForm" class="thirdGrid">
                            <div class="pb-10 px-20">
                                @if (showCropper) {
                                    <div>
                                        <image-cropper
                                                (imageCropped)="imageCropped($event)"
                                                [aspectRatio]="1"
                                                [imageChangedEvent]="imageChangedEvent"
                                                [maintainAspectRatio]="true"
                                                [resizeToWidth]="250"
                                                aria-label="Profile picture cropper (optional, the default centres the crop)"
                                                format="png"
                                        ></image-cropper>
                                    </div>
                                }
                                <img [src]="imgURL" alt="Profile Picture" class="w-100 imgControl">
                                <div class="flex-row flex-space-around">
                                    <div>
                                        @if (!showCropper) {
                                            <button (click)="fileInput.click()" (keyup.enter)="fileInput.click()"
                                                    color="primary" mat-raised-button>
                                                <span>Select New Profile Picture</span>
                                                <input #fileInput (change)="onFileChanged($event)"
                                                       accept="image/png, image/jpeg" class="d-none"
                                                       type="file"/>
                                            </button>
                                        }
                                    </div>
                                    @if (imgURL != 'assets/images/blankProfile.png' && imgURL != this.user?.photo) {
                                        <div class="flex-row gap-15">
                                            <button (click)="removeImage()" color="warn" mat-raised-button>Cancel
                                            </button>
                                            <button (click)="saveProfile()" color="accent" mat-raised-button>Upload
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div class="formGrid">
                                <mat-form-field appearance="outline" color="primary">
                                    <mat-label>First Name</mat-label>
                                    <input [disabled]="this.user?.role?.role_type !== 'admin'"
                                           autocomplete="given-name" formControlName="first_name"
                                           matInput required type="text">
                                    @if (this.user?.role?.role_type !== 'admin') {
                                        <button aria-label="First name: if you believe this field is incorrect please contact an administrator to change it"
                                                mat-icon-button matSuffix
                                                matTooltip="If you believe this field is incorrect please contact an administrator to change it">
                                            <mat-icon>info</mat-icon>
                                        </button>
                                    }
                                    @if (profileForm.controls['first_name'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="outline" color="primary">
                                    <mat-label>Last Name</mat-label>
                                    <input [disabled]="this.user?.role?.role_type !== 'admin'"
                                           autocomplete="family-name" formControlName="last_name"
                                           matInput required type="text">
                                    @if (this.user?.role?.role_type !== 'admin') {
                                        <button aria-label="Last name: if you believe this field is incorrect please contact an administrator to change it"
                                                mat-icon-button matSuffix
                                                matTooltip="If you believe this field is incorrect please contact an administrator to change it">
                                            <mat-icon>info</mat-icon>
                                        </button>
                                    }
                                    @if (profileForm.controls['last_name'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                    @if (profileForm.controls['last_name'].hasError('pattern')) {
                                        <mat-error>
                                            Last name cannot be blank
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="outline" color="primary">
                                    <mat-label>Email</mat-label>
                                    <input [disabled]="this.user?.role?.role_type !== 'admin' || this.user?.is_sso_user == true"
                                           autocomplete="email" formControlName="email" matInput required type="email">
                                    @if (this.user?.role?.role_type !== 'admin') {
                                        <button aria-label="Email: if you believe this field is incorrect please contact an administrator to change it"
                                                mat-icon-button matSuffix
                                                matTooltip="If you believe this field is incorrect please contact an administrator to change it">
                                            <mat-icon>info</mat-icon>
                                        </button>
                                    } @else if (this.user?.is_sso_user) {
                                        <button aria-label="Email address cannot be altered on users with SSO"
                                                mat-icon-button matSuffix
                                                matTooltip="Email address cannot be altered on users with SSO">
                                            <mat-icon>info</mat-icon>
                                        </button>
                                    }
                                    @if (profileForm.controls['email'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                    @if (profileForm.controls['email'].hasError('email')) {
                                        <mat-error>
                                            Please enter a valid email address
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="outline" color="primary">
                                    <mat-label>Username</mat-label>
                                    <input [disabled]="this.user?.role?.role_type !== 'admin' "
                                           autocomplete="username" formControlName="username"
                                           matInput required type="text">
                                    @if (this.user?.role?.role_type !== 'admin') {
                                        <button aria-label="Username: if you believe this field is incorrect please contact an administrator to change it"
                                                mat-icon-button matSuffix
                                                matTooltip="If you believe this field is incorrect please contact an administrator to change it">
                                            <mat-icon>info</mat-icon>
                                        </button>
                                    }
                                    @if (profileForm.controls['username'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>About Me</mat-label>
                                    <textarea #description formControlName="about_me" matInput maxlength="400"
                                              required></textarea>
                                    <app-emoji-menu [form]="profileForm" [input]="'about_me'"
                                                    matSuffix></app-emoji-menu>
                                    <mat-hint align="end">{{ description?.value?.length }} / 400</mat-hint>
                                    @if (profileForm.controls['about_me'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        </form>
                        <div class="w-100 text-center flex-space-evenly flex-row">
                            <button (click)="saveProfile()" [disabled]="profileForm.invalid" color="accent"
                                    mat-raised-button>
                                Save
                            </button>
                        </div>
                    </mat-tab>
                    <mat-tab label="Update Password">
                        <form [formGroup]="passwordForm" class="otherThirdGrid">
                            <div class="flex-col">
                                <mat-form-field appearance="outline" class="w-100 mb-10" color="primary">
                                    <mat-label>Current Password</mat-label>
                                    <input #currentPassword autocomplete="current-password"
                                           formControlName="currentPassword"
                                           matInput
                                           type="password">
                                    @if (passwordForm.controls['currentPassword'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-100 mb-10" color="primary">
                                    <mat-label>New Password</mat-label>
                                    <input #password autocomplete="new-password" formControlName="password" matInput
                                           type="password">
                                    @if (passwordForm.controls['password'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                    @if (passwordForm.controls['password'].hasError('pattern')) {
                                        <mat-error>
                                            The password must match all the requirements
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="w-100 mb-10" color="primary">
                                    <mat-label>Confirm New Password</mat-label>
                                    <input #confirmPassword autocomplete="new-password"
                                           formControlName="confirmPassword"
                                           matInput type="password">
                                    @if (passwordForm.controls['confirmPassword'].hasError('required')) {
                                        <mat-error>
                                            This field is required
                                        </mat-error>
                                    }
                                    @if (passwordForm.controls['confirmPassword'].hasError('pattern')) {
                                        <mat-error>
                                            The password must match all the requirements
                                        </mat-error>
                                    }
                                    @if (password.value != confirmPassword.value && !passwordForm.controls['confirmPassword'].hasError('pattern')) {
                                        <mat-error>
                                            Passwords do not match
                                        </mat-error>
                                    }
                                </mat-form-field>
                                <div class="col-12 text-center">
                                    <button (click)="editPassword()"
                                            [disabled]="passwordForm.invalid || password.value != confirmPassword.value"
                                            color="primary"
                                            mat-raised-button>
                                        Update
                                    </button>
                                </div>
                            </div>
                            <app-password-validator [length]="this.passwordLength"
                                                    [matching]="password.value != confirmPassword.value"
                                                    [password]="password.value"></app-password-validator>
                        </form>
                    </mat-tab>
                    @if (dynamicSettings?.font_accessibility) {
                        <mat-tab label="Accessibility">
                            <small id="fontAccessibilityHelp">
                                Changing these fields will alter the font on this page temporarily as an example unless
                                saved.
                            </small>
                            <form [formGroup]="accessibilityForm" class="formGrid mt-10">
                                <div>
                                    <mat-form-field appearance="outline" class=" w-100" color="primary">
                                        <mat-label>Font</mat-label>
                                        <mat-select (valueChange)="setFont($event)"
                                                    aria-describedby="fontAccessibilityHelp"
                                                    formControlName="fontFamily">
                                            <mat-option value="roboto">Default</mat-option>
                                            <mat-option value="OpenDyslexicAlta">Dyslexic accessible font</mat-option>
                                            <mat-option value="AtkinsonHyperlegible">Legibility font</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="d-flex flex-col w-100">
                                    <mat-label>Font size</mat-label>
                                    <mat-slider [displayWith]="formatLabel" discrete max="130" min="100" showTickMarks
                                                step="1">
                                        <input (valueChange)="setFontSize($event)"
                                               aria-describedby="fontAccessibilityHelp"
                                               aria-label="Font size" formControlName="fontSize"
                                               matSliderThumb>
                                    </mat-slider>
                                </div>
                            </form>
                            <div class="w-100 text-center mt-10">
                                <button (click)="saveAccessibility()" [disabled]="accessibilityForm.invalid"
                                        color="accent"
                                        mat-raised-button>Save
                                </button>
                            </div>
                        </mat-tab>
                    }
                </mat-tab-group>
            </mat-card-content>
        </mat-card>
    </div>
</main>
